import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthErrorBoundary, AuthProvider } from "@resmed/identity-spa-auth-react";
import App from "./App";
import AppProviders from "./providers/AppProviders";
import { TokenProvider } from "./context/TokenContext";
import "./index.css";
const clientId = process.env.AUTH_CLIENT_ID ?? "0oa2p830kwlQisIfE0h8";
const environment = process.env.AUTH_ENVIRONMENT ?? "dev-amr";
if (!process.env.AUTH_CLIENT_ID || !process.env.AUTH_ENVIRONMENT) {
    console.warn(
        "AUTH_CLIENT_ID or AUTH_ENVIRONMENT not set; using default dev auth configuration."
    );
}

// DEV_ACCESS_TOKEN is set in .env.local (git-ignored) for standalone local testing.
// It is never present in CI/CD or production builds.
const devToken = process.env.DEV_ACCESS_TOKEN ?? "";

createRoot(document.getElementById("root")!).render(
    <AuthErrorBoundary
        fallback={(error) => (
            <div>
                <h1>Authentication error</h1>
                <p>{error.message}</p>
            </div>
        )}
    >
        <AuthProvider clientId={clientId} environment={environment}>
            <TokenProvider value={{ accessToken: devToken, residentId: "", facilityId: "", userId: "" }}>
                {/* AppProviders (SocketProvider) is outside StrictMode so socket connects exactly once */}
                <AppProviders>
                    <StrictMode>
                        <App />
                    </StrictMode>
                </AppProviders>
            </TokenProvider>
        </AuthProvider>
    </AuthErrorBoundary>
);
